__turbopack_context__.v({
  "empty": "MessagesList-module__8W69VG__empty",
  "item": "MessagesList-module__8W69VG__item",
  "itemBody": "MessagesList-module__8W69VG__itemBody",
  "itemDate": "MessagesList-module__8W69VG__itemDate",
  "itemPreview": "MessagesList-module__8W69VG__itemPreview",
  "itemSender": "MessagesList-module__8W69VG__itemSender",
  "itemSkeleton": "MessagesList-module__8W69VG__itemSkeleton",
  "itemSkeletonDate": "MessagesList-module__8W69VG__itemSkeletonDate",
  "itemSkeletonSender": "MessagesList-module__8W69VG__itemSkeletonSender",
  "itemSkeletonTitle": "MessagesList-module__8W69VG__itemSkeletonTitle",
  "itemTitle": "MessagesList-module__8W69VG__itemTitle",
  "itemUnread": "MessagesList-module__8W69VG__itemUnread",
  "list": "MessagesList-module__8W69VG__list",
  "pagBtn": "MessagesList-module__8W69VG__pagBtn",
  "pagInfo": "MessagesList-module__8W69VG__pagInfo",
  "pagination": "MessagesList-module__8W69VG__pagination",
});
